export const NGSI_LD_API_EVENTS = {
  QUERY_ENTITY_BY_ID_PATTERN: 'queryIdPatternEvent',
  QUERY_ENTITY_BY_ID: 'queryEntityByIdEvent',
  QUERY_ENTITIES_BY_ID: 'queryEntitiesByIdEvent',
  QUERY_ENTITY_BY_TYPE: 'queryEntityTypeEvent',
  CREATE_SUBSCRIPTION: 'createSubscriptionEvent',
  UPDATE_SUBSCRIPTION: 'updateSubscriptionEvent',
  DELETE_SUBSCRIPTION: 'deleteSubscriptionEvent',
};

export const PLUGIN_CONFIG_EVENTS = {
  TRANSMIT_CONFIG: 'transmitConfigEvent',
};

export const NGSI_LD_NOTIFICATION_EVENTS = {
  NOTIFICATION: 'notificationEvent',
  GEOQ_NOTIFICATION: 'notificationGeoQEvent'
}
